import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

const FooterSection = () => {
  const [isDevOk, setIsDevOk] = useState(false);

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (!localStorage.is_dev) { console.log('var not initialized'); localStorage.setItem("is_dev", 0); }

    if (parseInt(localStorage.getItem("is_dev")) > 6) setIsDevOk(true);

  }, [parseInt(localStorage.getItem("is_dev"))]);

  return (
    <div className='flex items-center space-x-3 pt-10'>
      <div
        title={parseInt(localStorage.getItem("is_dev")) > 6 ? 'Congratulations ! you are a developer now :D' : 'Click 7 times to become a developer ;) '}
        onClick={() => {
          console.log('localData', parseInt(localStorage.getItem("is_dev")));
          if (parseInt(localStorage.getItem("is_dev")) > 6) setIsDevOk(true);

          localStorage.setItem("is_dev", (parseInt(localStorage.getItem("is_dev")) + 1));
        }}
        className='text-gray-800 dark:text-cDarkText'>
        © ZamanShahed {currentYear}
      </div >
      {
        isDevOk ?
          <Link className='text-blue-400 font-semibold underline italic' to={'/play'}>Let's PLAY</Link>
          : ""
      }
    </div>
  )
}

export default FooterSection